import React, { useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Skeleton } from 'antd';
import { StoreContext } from '../store/index';

const PrivateRoute = ({ children }) => {
  const store = useContext(StoreContext);
  const {
    user: [user, setUser],
    isStoreLoading: [isStoreLoading, setIsStoreLoading],
  } = store || {};

  const location = useLocation();

  return (
    <div>
      {isStoreLoading && <Skeleton active />}
      {!isStoreLoading && !user && (
        <Navigate to={`/login${location.search}`} replace />
      )}
      {!isStoreLoading && user && children}
    </div>
  );
};
export default PrivateRoute;
